import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router';
import  axios  from  'axios';
import VCurrencyField from 'v-currency-field';
import { VTextField } from 'vuetify/lib'  //Globally import VTextField
import HighchartsVue from "highcharts-vue";

export const radio = new Vue();

Vue.config.productionTip = false;
Vue.prototype.$axios  =  axios;
Vue.prototype.$radio = radio;
Vue.prototype.$apiurl = 'https://erp.inovenso.com/erp/';

axios.interceptors.request.use(function(config) {        
  config.headers.common['access_token'] = localStorage.getItem('access_token');
  config.headers.common['refresh_token'] = localStorage.getItem('refresh_token');  
  return config;
}, function(error) {
  return Promise.reject(error);
});   

axios.interceptors.response.use((response) => {
  if (response.status === 401) {
      router.push("/login") 
  } 
  if(response.headers.access_token && response.headers.access_token!='undefined'){
    localStorage.setItem('access_token', response.headers.access_token);
  }
  return response;
  
  }, function (error) {
    radio.$emit('showprogress', false);
    if (error.response.status === 401) {          
        router.push('/login')
    }
    if (error.response.status === 500) {       
      radio.$emit('error', error);
    }
    return Promise.reject(error);
  });

Vue.component('v-text-field', VTextField);
Vue.use(VCurrencyField, { 
  locale: 'tr-TR',
  decimalLength: 2,
  autoDecimalMode: true,
  min: null,
  max: null,
  defaultValue: 0
});

Vue.use(HighchartsVue);

new Vue({
  vuetify,
  router,
  VCurrencyField,
  render: h => h(App)
}).$mount('#app')
